import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { API_BASE_URL } from '../constants/api';

// QTQMS CAPA Tracker — read-only.
//
// Everything goes through OUR backend, never qtqms directly:
//   · the API key is server-side only (it would be readable in a JS bundle)
//   · qtqms sends no CORS headers for this origin
//   · the upstream has no per-centre filter, so the backend scopes the list
//     to the CAPAs linked to queries this user raised
//
//   GET /portal/capa/records        — list (already filtered + re-counted)
//   GET /portal/capa/records/{code} — one CAPA
//
// No mutations: changing a CAPA is done in QTQMS itself.

export const capaApi = createApi({
  reducerPath: 'capaApi',
  baseQuery: createAuthBaseQuery(API_BASE_URL),
  tagTypes: ['Capa'],
  endpoints: (builder) => ({
    listCapa: builder.query({
      query: ({ status, search, page = 1, perPage = 25 } = {}) => {
        const qs = new URLSearchParams({ page, per_page: perPage });
        if (status) qs.set('status', status);
        if (search) qs.set('search', search);
        return `/portal/capa/records?${qs.toString()}`;
      },
      providesTags: ['Capa'],
    }),

    getCapa: builder.query({
      query: (key) => `/portal/capa/records/${encodeURIComponent(key)}`,
      providesTags: ['Capa'],
    }),
  }),
});

export const { useListCapaQuery, useGetCapaQuery } = capaApi;
